import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReturnOrdersExistenceParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품교환관리] 반품 신청 여부 조회 api 요청 훅
 */
const useGetReturnOrdersExistence = () => {
  const { runAsync } = useAsyncHandler();

  const getReturnOrdersExistence = useAPI<TypeGetReturnOrdersExistenceParams, boolean & { data: unknown }>({
    endpoint: API_ENDPOINT.CLAIM.GET_RETURN_ORDERS_EXISTENCE,
    method: 'get',
  });

  const requestReturnOrdersExistence = async (
    params: TypeGetReturnOrdersExistenceParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: boolean) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getReturnOrdersExistence({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestReturnOrdersExistence };
};

export default useGetReturnOrdersExistence;
